// extracted by mini-css-extract-plugin
export default {"root":"hZ2RoA"};